import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import $ from 'npm-zepto';

import { createContainer } from '@dbk-legacy/muster/react';

import { Large, Small } from '../text';

import Button from '../button';
import styles from './rsa.styles';
import { LoadingCircle } from '../loading';

const MAX_RSA = 8;

class RSAPIN extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      rsaPin:'',
      rsaPinConfirm:'',
      isLoading : false,
      reconfirm: false,
      pinsucess: false,
      newPin1: '',
      newPin2: '',
      newPin3: '',
      newPin4: '',
      newPin5: '',
      newPin6: '',
      newPin7: '',
      newPin8: '',
      confirmPin1: '',
      confirmPin2: '',
      confirmPin3: '',
      confirmPin4: '',
      confirmPin5: '',
      confirmPin6: '',
      confirmPin7: '',
      confirmPin8: '',
    };
    this.handleValidatePin = this.handleValidatePin.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.isInvalidPin = this.isInvalidPin.bind(this);
    this.showInvalidAlert = this.showInvalidAlert.bind(this);
    this.finishRsaPin = this.finishRsaPin.bind(this);
  }

  componentDidMount() {
    this.refs.newPin1.focus();
  }

  isInvalidPin(pin){ /* 4 to 8 digit limit */
    if(pin.length < 4 || pin.length >  8){
      return true;
    }
    return false;
  }

  showInvalidAlert() {
    const { i18n: { messages }} = this.props;
    alert(messages['app.rsa.enterDigitPin']);
    this.setState({isLoading: false});
  }

  handleValidatePin() {
    const { i18n: { messages }} = this.props;
    this.setState({isLoading: true});

    const {newPin1, newPin2, newPin3, newPin4, newPin5, newPin6, newPin7, newPin8, confirmPin1, confirmPin2, confirmPin3, confirmPin4, confirmPin5, confirmPin6, confirmPin7, confirmPin8 } = this.state;
    let newPin = newPin1.toString() + newPin2.toString() + newPin3.toString() + newPin4.toString() + newPin5.toString() + newPin6.toString() + newPin7.toString() + newPin8.toString();
    let confirmPin = confirmPin1.toString() + confirmPin2.toString() + confirmPin3.toString() + confirmPin4.toString() + confirmPin5.toString() + confirmPin6.toString() + confirmPin7.toString() + confirmPin8.toString();

    const {
      settings: {
        currentEnvironment: { remoteUrl },
      },
      auth: { userId, authHeader},
    } = this.props;

    if (this.isInvalidPin(confirmPin)){
       this.showInvalidAlert();
    }
    else if(newPin !== confirmPin){
      this.setState({isLoading: false});
      alert(messages['app.rsa.pinNotMatch']);
    }
    else if (remoteUrl != null) { /* TODO : need to handle pin and confirm pin API CALL */
      console.log("## : remoteUrl: " , remoteUrl);
      const RSA_URL = remoteUrl + "/pbauthentication/" + this.props.app.config.apiverion + "/set-newpin"
      const inputs = {
          'userId': userId,
          'tokenId': confirmPin
          };
      $.ajax({
        type: 'POST',
        url: RSA_URL,
        headers: {
                  'Accept': 'application/json',
                  'Cache-Control' : 'no-cache',
                  'Content-Type': 'application/json',
                  'Authorization-Token' : authHeader
                },
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(inputs),
        success: function(responseJson) {
           this.routePage(responseJson.retCode, responseJson.jwt);
           this.setState({isLoading: false});
        }.bind(this),
        error: function (request, status, error) {
          console.log("error", error);
            this.setState({isLoading: false, reconfirm: false, confirmPin1: '',confirmPin2: '',confirmPin3: '',confirmPin4: '',confirmPin5: '',confirmPin6: '',confirmPin7: '',confirmPin8: ''});
            alert('Server not reachable. Please try after some time.');
          }.bind(this)
        });

      /*fetch(RSA_URL, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },

      }).then((response) => response.json())
        .then((responseJson) => {
          this.routePage(responseJson.retCode, responseJson.jwt);
          this.setState({isLoading: false});
        })
        .catch((error) => {
          this.setState({isLoading: false});
          this.setState({reconfirm: false});
          this.pin1Update('');
          this.pin2Update('');
          alert('Server not reachable. Please try after some time.');
        }); */
    }
    else {
        console.log("##: handleValidatePin : at static sucess ")
        this.routePage(6, ''); /*static sucess*/
    }
  }

  finishRsaPin(){
    if(this.props.rsa.onHideRsaPin){ /*android crash if call direct on press*/
      this.props.rsa.onHideRsaPin();
    }

  }

  routePage(rsaTokenStatus, jwt) {
    const { i18n: { messages }} = this.props;
    if (rsaTokenStatus == 6) {
      this.setState({pinsucess: true, isLoading: false});
    }
    else {
      /*setpin api fails ... so reset the screen */
      this.setState({isLoading: false, reconfirm: false,confirmPin1: '',confirmPin2: '',confirmPin3: '',confirmPin4: '',confirmPin5: '',confirmPin6: '',confirmPin7: '',confirmPin8: ''});
      alert(messages['pp.rsa.tryAgain']);
    }
  }

handlePinKeyUp(index, event) {
    const { nativeEvent: { key } } = event;
    const prevIndex = index > 1 ? index - 1 : 1;
    const nextIndex = index < MAX_RSA ? index + 1 : MAX_RSA;

    if (key === 'Backspace') {
      this.refs[`newPin${prevIndex}`].focus();
      let newState = {};
      newState[`newPin${index}`] = '';
      this.setState(newState);
    }
  }

handlePinPress(index, event) {
    const { nativeEvent: { key } } = event;
    const prevIndex = index > 1 ? index - 1 : 1;
    const nextIndex = index < MAX_RSA ? index + 1 : MAX_RSA;

    if(key == "Enter") {
       this.handleNext();
    } else  {
      let newState = {};
      newState[`newPin${index}`] = event.key;
      this.setState(newState);
      setTimeout(function() {
        this.refs[`newPin${nextIndex}`].focus();
      }.bind(this), 100);
    }

  }

  handleNext(){
    const { i18n: { messages }} = this.props;
    const {newPin1, newPin2, newPin3, newPin4, newPin5, newPin6, newPin7, newPin8 } = this.state;
    var newPin = newPin1.toString() + newPin2.toString() + newPin3.toString() + newPin4.toString() + newPin5.toString() + newPin6.toString() + newPin7.toString() + newPin8.toString();
    let isnum = /^\d+$/.test(newPin);
    if(!isnum) {
      alert(messages['app.token.numeric.characters']);
    }
    else if(this.isInvalidPin(newPin)){
      this.showInvalidAlert();
    }else{
      this.setState({reconfirm: true});
    }
  }

 handleConfirmPinUp(index, event) {
    const { nativeEvent: { key } } = event;
    const prevIndex = index > 1 ? index - 1 : 1;
    const nextIndex = index < MAX_RSA ? index + 1 : MAX_RSA;

    if (key === 'Backspace') {
      let newState = {};
      newState[`confirmPin${index}`] = '';
      this.setState(newState);
      setTimeout(function() {
      this.refs[`confirmPin${prevIndex}`].focus();
      }.bind(this), 100);
    }
  }

  handleConfirmPinKeyPress(index, event) {
    const { nativeEvent: { key } } = event;
    const prevIndex = index > 1 ? index - 1 : 1;
    const nextIndex = index < MAX_RSA ? index + 1 : MAX_RSA;

    if(key == "Enter") {
       this.handleValidatePin();
    } else  {
      let newState = {};
      newState[`confirmPin${index}`] = event.key;
      this.setState(newState);
      setTimeout(function() {
        this.refs[`confirmPin${nextIndex}`].focus();
      }.bind(this), 100);
    }
  }


  renderContent(){

    const {
      rsaPin,
      rsaPinConfirm,
      isLoading,
      reconfirm,
      pinsucess,
    } = this.state;
    const {
      i18n: { messages },
    } = this.props;


    let numbers = [1,2,3,4,5,6,7,8];
    let newPinList = numbers.map((number) => {
    let dataId = "newPin"+number;
    return (<input type="password" className="inputBox" maxLength={1}
            ref={dataId}
            data-id={dataId}
            key={dataId}
            value={this.state[`newPin${number}`]}
            onKeyUp={(event) => this.handlePinKeyUp(number, event)}
            onKeyPress={(event) => this.handlePinPress(number, event)}
      />)
    });

    let confirmPinList = numbers.map((number) => {
    let confirmId = "confirmPin" + number;
    return (<input type="password" className="inputBox" maxLength={1}
            ref={confirmId}
            data-id={confirmId}
            key={confirmId}
            value={this.state[`confirmPin${number}`]}
            onKeyUp={(event) => this.handleConfirmPinUp(number, event)}
            onKeyPress={(event) => this.handleConfirmPinKeyPress(number, event)}
      />)
    });

    if(this.state.pinsucess){
      return (
        <div className="scene" >
           <div className="row change-password">
              <div className="columns small-push-2 small-8 text-center paddingClass">
                 <div className="callout module">
                    <div className="pad-bottom-10">
                       <h4>{messages['app.pin.update.sucess.text']}</h4>
                    </div>
                    <Button title={messages['app.rmcallback.okMsg']}
                     size="normal"
                     onPress={this.finishRsaPin}
                     />
                 </div>
              </div>
           </div>
        </div>
      );

    }
    else if(!this.state.reconfirm){
      return (
              <div className="scene" >
                 <div className="row change-password">
                    <div className="columns small-push-2 small-8 text-center paddingClass">
                       <div className="callout module">
                          <Small style={styles.textinfo}>
                          {messages['app.pin.header.title.text']}
                          </Small>
                          <div className="pad-bottom-10">
                             <Large  style={styles.textCenter}>
                                {messages['app.pin.header.label.text']}
                             </Large>
                          </div>

                      <div className="row">
                      <div className="column small-12 medium-push-2 medium-8 large-push-3 large-6">
                      <div className="flexClass">
                        {newPinList}
                      </div>
                        <Button title={messages['app.rsa.nextText']}
                         size="normal"
                         onPress={this.handleNext}
                         />
                      </div>
                    </div>

                       </div>
                    </div>
                 </div>
              </div>
      );

  }else{

      return(
          <div className="scene" >
           <div className="row change-password">
              <div className="columns small-push-2 small-8 text-center paddingClass">
                 <div className="callout module">
                    <Small style={styles.textinfo}>
                    {messages['app.pin.header.title.text']}
                    </Small>
                    <div className="pad-bottom-10">
                       <Large  style={styles.textCenter}>
                          {messages['app.pin.header.label.text.reconfirm']}
                       </Large>
                    </div>

                      <div className="row">
                      <div className="column small-12 medium-push-2 medium-8 large-push-3 large-6">
                      <div className="flexClass">
                        {confirmPinList}
                      </div>
                       <Button title={messages['app.rsa.validatePin']}
                       size="normal"
                       style={styles.validateToken}
                       onPress={this.handleValidatePin}
                       />
                      </div>
                    </div>
                 </div>
              </div>
           </div>
        </div>
      );
  }
}

render() {
    const {
      rsaPin,
      rsaPinConfirm,
      isLoading,
      reconfirm,
    } = this.state;
    return (
      <div>
       {isLoading ? <LoadingCircle/> : this.renderContent()}
      </div>

    );
  }
}

RSAPIN.propTypes = {
  rsa: PropTypes.shape({
    deviceToken: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        service: PropTypes.string,
        username: PropTypes.string,
        password: PropTypes.string,
      }),
    ]),
    onValidateToken: PropTypes.func,
    onValidateDevice: PropTypes.func,
    onChangePage : PropTypes.func,
    onHideRsa: PropTypes.func,
    onHideRsaPin: PropTypes.func,
    onShowRsaPin: PropTypes.func,
  }),
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
};

export default createContainer({
  $queries: {
    app:{
      config: {
        apiverion: true
      }
    },
    rsa: {
      onValidateToken: { $call: 'validateToken' },
      rsaAuthorised: true,
      rsaVisible: true,
      onChangePage: {$call: 'changePage'},
      onHideRsa: {$call: 'hideRsa'},
      onShowRsaPin:{ $call:'showRsaPin'},
      onHideRsaPin:{ $call:'hideRsaPin'},
    },
    screen:{
      width:true,
      height:true,
      isSmall:true
    },
    i18n: {
      messages: true,
    },
    auth: {
      userId: true,
      authHeader: true,
    },
    settings: {
      currentEnvironment: {
        remoteUrl: true,
      },
    },
  }
})(RSAPIN);
